import { render, staticRenderFns } from "./DashboardZero.vue?vue&type=template&id=9f0a32e8&"
import script from "./DashboardZero.vue?vue&type=script&lang=js&"
export * from "./DashboardZero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports